import { DropDownData } from "../../../api/services/common/models";
import { UserDetails } from "../../../helpers/types/common";

export const CreateNISParticipantFormKey = {
  // profile section
  nisId: "nisId",
  participantFirstName: "participantFirstName",
  participantLastName: "participantLastName",
  jobTitle: "jobTitle",
  participantEmail: "participantEmail",
  participantWorkEmail: "participantWorkEmail",
  participantMobile: "participantMobile",
  participantMobileCountryCode: "participantMobileCountryCode",
  participantMobileISOCode: "participantMobileISOCode",

  // professional details section
  country: "country",
  clientEmployer: "clientEmployer",
  clientEmployerOther: "clientEmployerOther",
  projectManagerId: "projectManagerId",
  employeeId: "employeeId",
  releaseDate: "releaseDate",
  hrContact: "hrContact",
  hrContactNameOther: "hrContactNameOther",
  hrContactEmailIdOther: "hrContactEmailIdOther",
  severanceStatusSigned: "severanceStatusSigned",

  // address details section
  address1: "address1",
  address2: "address2",
  address3: "address3",
  countryAddress: "countryAddress",
  city: "city",
  stateProvince: "stateProvince",
  postalCode: "postalCode",
} as const;

export const ChangeNISStatusFormKey = {
  status: "status",
  notes: "notes",
} as const;

export const ConvertedToP3SiteCoreKey =
  "CreateNewNISParticipant.ActivityTimeline.ConvertedToP3";

export const NISParticipantActivityTimelineFilterFormKey = {
  show: "show",
  fromDate: "fromDate",
  toDate: "toDate",
} as const;

export const NISAddActivityFormKey = {
  activityType: "activityType",
  modality: "modality",
  topic: "topic",
  notes: "notes",
} as const;

export const NISAddActivityDefaultFormValue = {
  [NISAddActivityFormKey.activityType]: "",
  [NISAddActivityFormKey.modality]: [],
  [NISAddActivityFormKey.topic]: [],
  [NISAddActivityFormKey.notes]: "",
};

export interface NISParticipantActivityTimelineFilterFormType {
  show: string;
  fromDate: string;
  toDate: string;
}

export interface CreateNISParticipantParams {
  participantFirstName: string;
  participantLastName: string;
  jobTitle?: string;
  participantEmail: string;
  participantWorkEmail?: string;
  participantMobile?: string;
  participantMobileCountryCode?: string;
  participantMobileISOCode?: string;
  country: string;
  clientEmployer: string;
  clientEmployerOther?: string;
  projectManagerId: string;
  employeeId?: string;
  releaseDate?: string;
  hrContact?: string;
  hrContactNameOther?: string;
  hrContactEmailIdOther?: string;
  severanceStatusSigned?: string;
  address1?: string;
  address2?: string;
  address3?: string;
  countryAddress?: string;
  city?: string;
  stateProvince?: string;
  postalCode?: string;
}

export const VALUE_OTHER = "Other";
export const GEO_SCOPE_NORTH_AMERICA = "NA";
export const CLIENT_SERVICES_EMAIL = "clientservices@right.com";
export const OTHER_DROPDOWN_ITEM: DropDownData = {
  id: VALUE_OTHER,
  name: VALUE_OTHER,
};
export const OTHER_DROPDOWN_FOR_HR_CONTACT: UserDetails = {
  id: VALUE_OTHER,
  firstName: VALUE_OTHER,
  lastName: "",
};

export const NIS_PARTICIPANTS_ACCORDION_KEYS = {
  all: "all",
  profile: "profile",
  professionalDetails: "professionalDetails",
  addressDetails: "addressDetails",
  nisStatus: "nisStatus",
  activityTimeline: "activityTimeline",
};

export const ViewNISParticipantStatusResultKey = {
  createdDate: "createdDate",
  statusId: "statusId",
  createdBy: "createdBy",
  notes: "notes",
} as const;
